<app-card>
  <div class="flex flex-col items-start justify-between h-full min-h-[140px]">
    <!-- Leading icon -->
    @if (icon()) {
      <div class="mb-3">
        <app-icon [name]="icon()" size="lg" class="opacity-90"></app-icon>
      </div>
    }

    <!-- Title + subtitle -->
    <div class="flex-1">
      @if (title()) {
        <div class="text-lg font-semibold text-body mb-1">{{ title() }}</div>
      }
      @if (subtitle()) {
        <p class="text-base text-muted mb-3">{{ subtitle() }}</p>
      }
    </div>

    <!-- Trailing action button -->
    <div>
      <app-button
        [color]="buttonColor()"
        fill="solid"
        shape="round"
        size="small"
        expand="block"
        (click)="onActionClick()"
      >
        {{ buttonLabel() }}
        <app-icon name="arrow-forward" size="xs"></app-icon>
      </app-button>
    </div>
  </div>
</app-card>
